export function formatAmount(amount) {
  const value = Number(amount ?? 0);
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(value));
}

export function computePricing(monthlyPlan, annualPlan, isAnnual) {
  const monthly = monthlyPlan?.recurlyPlanCodePrice ?? 0;
  const annual = annualPlan?.recurlyPlanCodePrice ?? 0;

  if (!isAnnual) {
    const denom = monthly * 12 || 1;
    const savePct = Math.max(0, 100 * (1 - annual / denom));
    return {
      line1Main: `$${formatAmount(monthly)}`,
      line1Suffix: '/month',
      line2: `or go annual and save ${savePct.toFixed(0)}%!`,
    };
  }

  // return {
  //   line1Main: `$${formatAmount(Math.round(annual / 12))}`,
  //   line1Suffix: '/month',
  //   line2: `$${formatAmount(annual)} paid annually`,
  // };
  return {
    line1Main: `$${formatAmount((annual))}`,
    line1Suffix: '/year',
    line2: '',
  };
}

export function boardsCountLabel(count) {
  if (count === -1) return 'Unlimited';
  if (count === 0) return 'Explore';
  if (count === 1) return 'Join 1 board';
  if (typeof count === 'number' && count > 1)
    return `Join up to ${count} boards`;
  return '-';
}

function boardsCountBulletContent(count) {
  if (count === -1) {
    return (
      <>
        Join <strong>unlimited</strong> boards
      </>
    );
  }
  if (count === 0) {
    return 'Explore advisory boards';
  }
  if (count === 1) {
    return (
      <>
        Join your <strong>first</strong> advisory board
      </>
    );
  }
  if (typeof count === 'number' && count > 1) {
    return (
      <>
        Join up to <strong>{count} advisory boards</strong>
      </>
    );
  }
  return 'Join advisory boards';
}

const bulletTemplates = {
  1: [
    (count) => boardsCountBulletContent(count),
    'Join or leave your board at any time',
    'Enjoy valuable perks & rewards',
  ],
  2: [
    (count) => boardsCountBulletContent(count),
    'Perks & rewards from multiple boards',
    'Build a portfolio of advisory boards',
    'Engage in senior-level networking',
  ],
  3: [
    (count) => boardsCountBulletContent(count),
    <>Become a <strong>Featured Advisor</strong></>,
    'Exclusive Executive Interview',
    'Quarterly Thought Leadership',
    'Annual Review & Recommendations',
  ],
};

export function getPlanBullets(option, count) {
  const template = bulletTemplates[option] || [];
  return template.map((entry) =>
    typeof entry === 'function' ? entry(count) : entry
  );
}
